import { DSAlertTitle } from '../../../mui';

export const HelpPopperTitle = DSAlertTitle;
